import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { NeshImagemRepresentation } from "src/app/core/models/nesh-imagem.model";
import { NeshService } from "../nesh.service";

@Injectable({
  providedIn: "root",
})
export class NeshImagensResolver {
  private service = inject(NeshService);

  resolve() {
    return this.service.getImagens();
  }
}
